import { useNavigate } from "react-router-dom";

const fmt = require("indian-number-format");

export default function TopCard({ profile }) {
  const navigate = useNavigate();

  const credit = Number(profile.deposit_total || 0);
  const pl = Number(profile.profit_loss || 0);
  const allowCash = Number(profile.nse_cash || 0);
  const deposit_interest = Number(profile.deposit_interest || 0);
  const isDollar = Number(profile.rupee_dollar || 0);

  const onDeposit = () => {
    navigate("/Deposit");
  };
  const onWithdraw = () => {
    navigate("/Withdrawal");
  };

  return (
    <div className="relative w-full px-5 py-6 border-2 border-[var(--hover)] rounded-2xl bg-[var(--background)] backdrop-blur-md">
      {/* ACCOUNT TYPE BADGE */}
      <span
        className={`absolute top-3 right-3 text-white text-xs font-medium px-3 py-1 rounded-full shadow-sm ${
          profile.demo === 1 ? "bg-[var(--sellmeta)]" : "bg-[var(--buymeta)]"
        }`}
      >
        {profile.demo === 1 ? "Demo Account" : "Real Account"}
      </span>

      {/* USERNAME */}
      <h3 className="text-xl font-bold text-[var(--text)] tracking-wide">
        {profile.username}
      </h3>

      {/* COMPANY */}
      <p className="text-sm mt-1 text-[var(--subtext)] font-medium">
        {profile.company}
      </p>

      {/* SERVER */}
      <div className="flex justify-between items-center mt-3">
        <div className="px-3 py-1 bg-[var(--background)] uppercase border-2 border-[var(--hover)] rounded-xl text-xs font-semibold text-[var(--text)]">
          Server: {profile.server}
        </div>
      </div>
      {/* DOLLAR */}

      {profile.intraday_sq === 1 ? (
        isDollar === 0 ? (
          <div className="flex justify-between items-center mt-3">
            <div className="px-3 py-1 bg-[var(--background)] uppercase border-2 border-[var(--hover)] rounded-xl text-xs font-semibold text-[var(--text)]">
              Dollar Rate: {profile.dollar_rate}
            </div>
          </div>
        ) : null
      ) : null}

      {/* CREDIT */}
      <div className="mt-5 flex justify-between items-center bg-[var(--background)] border border-[var(--hover)] px-4 py-3 rounded-xl shadow-sm">
        <div className="text-left">
          <p className="text-xs text-[var(--subtext)] font-medium">Credit</p>
          <p className="text-lg font-bold text-[var(--buymeta)]">
            {fmt.format(Math.abs(credit).toFixed(2))}{" "}
            {isDollar === 1 ? "$ " : ""}
          </p>
        </div>
      </div>

      {/* PROFIT LOSS */}
      <div className="mt-3 flex justify-between items-center bg-[var(--background)] border border-[var(--hover)] px-4 py-3 rounded-xl shadow-sm">
        <div className="text-left">
          <p className="text-xs text-[var(--subtext)] font-medium">Booked</p>
          <p
            className={`text-lg font-bold ${
              pl >= 0 ? "text-[var(--buymeta)]" : "text-[var(--sellmeta)]"
            }`}
          >
            {fmt.format(Math.abs(pl).toFixed(2))} {isDollar === 1 ? "$ " : ""}
          </p>
        </div>
      </div>

      {allowCash === 1 && deposit_interest > 0 ? (
        <div className="mt-3 flex justify-between items-center bg-[var(--background)] border border-[var(--hover)] px-4 py-3 rounded-xl shadow-sm">
          <div className="text-left">
            <p className="text-xs text-[var(--subtext)] font-medium">
              Cash Deposit
            </p>
            <p className={`text-lg font-bold text-[var(--buy)]`}>
              {fmt.format(Math.abs(deposit_interest).toFixed(2))}{" "}
              {isDollar === 1 ? "$ " : ""}
            </p>
          </div>
        </div>
      ) : null}

      {/* DEPOSIT & WITHDRAW BUTTONS */}

      {profile.intraday_sq === 1 ? (
        <div className="mt-5 flex gap-3">
          <button
            onClick={onDeposit}
            className="w-1/2 py-2 rounded-xl font-semibold text-white bg-[var(--primary)] shadow-md hover:scale-[1.03] transition"
          >
            Deposit
          </button>

          <button
            onClick={onWithdraw}
            className="w-1/2 py-2 rounded-xl font-semibold text-white bg-[var(--sell)] shadow-md hover:scale-[1.03] transition"
          >
            Withdraw
          </button>
        </div>
      ) : null}
    </div>
  );
}
